import * as IApp from "./app.interface";
export { IApp };
